import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { config } from './config';

export const initializeSentry = () => {
  const isSentryEnabled = config.features.sentry.enabled && !import.meta.env.DEV;

  if (isSentryEnabled) {
    try {
      Sentry.init({
        dsn: SENTRY_CONTAINER,
        integrations: [new BrowserTracing()],
        environment: config.environment,
        release: RELEASE_ID
      });
    } catch (err) {
      console.log(err);
    }
  }
};
